module.exports = {"tr":{"ds":{"modal":{"ok":"Tamam","cancel":"İptal"}}}}